import { render, staticRenderFns } from "./viewLoanRequests.vue?vue&type=template&id=f061f960&scoped=true"
import script from "./viewLoanRequests.vue?vue&type=script&lang=js"
export * from "./viewLoanRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f061f960",
  null
  
)

export default component.exports